export default __webpack_public_path__ + "static/media/29.215bc04d.png";